// src/redux/contactSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Configuration from "../configuration";

// Fetch all contacts
export const fetchContacts = createAsyncThunk("contacts/fetchAll", async () => {
  const token = localStorage.getItem("x-access-token");
  const response = await fetch(
    Configuration.BACK_BASEURL + "users-contact/contact",
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        /* "x-access-token": token, */
      },
    },
  );
  const contacts = await response.json();
  return contacts;
});

// Fetch contact by ID
export const fetchContactById = createAsyncThunk(
  "contacts/fetchById",
  async (id) => {
    const token = localStorage.getItem("x-access-token");
    const response = await fetch(
      Configuration.BACK_BASEURL + `users-contact/contact/${id}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          /* "x-access-token": token, */
        },
      },
    );
    const contact = await response.json();
    return contact;
  },
);

// Update contact status
export const updateContactStatus = createAsyncThunk(
  "contacts/updateStatus",
  async ({ id, status }) => {
    const token = localStorage.getItem("x-access-token");
    const response = await fetch(
      Configuration.BACK_BASEURL + `users-contact/contact/${id}`,
      {
        method: "PATCH",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          /*  "x-access-token": token, */
        },
        body: JSON.stringify({ status }),
      },
    );

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || "Failed to update status");
    }

    const contact = await response.json();
    return contact;
  },
);

// Delete contact
export const deleteContact = createAsyncThunk("contacts/delete", async (id) => {
  const token = localStorage.getItem("x-access-token");
  const response = await fetch(
    Configuration.BACK_BASEURL + `users-contact/contact/${id}`,
    {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        /*  "x-access-token": token, */
      },
    },
  );

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || "Failed to delete contact");
  }

  return id;
});

const contactSlice = createSlice({
  name: "contacts",
  initialState: {
    entities: [],
    currentContact: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch all contacts
      .addCase(fetchContacts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchContacts.fulfilled, (state, action) => {
        state.loading = false;
        state.entities = action.payload;
      })
      .addCase(fetchContacts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // Fetch contact by ID
      .addCase(fetchContactById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchContactById.fulfilled, (state, action) => {
        state.loading = false;
        state.currentContact = action.payload;
      })
      .addCase(fetchContactById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // Update contact status
      .addCase(updateContactStatus.fulfilled, (state, action) => {
        const index = state.entities.findIndex(
          (contact) => contact.id === action.payload.id,
        );
        if (index !== -1) {
          state.entities[index] = action.payload;
        }
        if (state.currentContact?.id === action.payload.id) {
          state.currentContact = action.payload;
        }
        state.error = null;
      })
      // Delete contact
      .addCase(deleteContact.fulfilled, (state, action) => {
        state.entities = state.entities.filter(
          (contact) => contact.id !== action.payload,
        );
        if (state.currentContact?.id === action.payload) {
          state.currentContact = null;
        }
        state.error = null;
      });
  },
});

export const { clearError } = contactSlice.actions;
export default contactSlice.reducer;
